import clsx from 'clsx'
import { Avatar } from '../Avatar'
import styles from './styles.module.scss'
import { IAvatarGroupProps } from './types'

export default function AvatarGroup({
  avatars,
  max = 4,
  size = 'md',
  variant = 'default',
  hasBorder = false,
  className,
  ...props
}: IAvatarGroupProps) {
  return (
    <div
      className={clsx(
        'mui-avatar-group',
        styles.wrapper,
        styles[size],
        styles[variant],

        {
          [styles.bordered]: hasBorder,
        },
        className,
      )}
      data-testid="mui-avatar-group"
      {...props}
    >
      {avatars.slice(0, max).map((props, index) => (
        <Avatar {...props} size={size} className={styles.avatarInAvatarGroup} key={index} />
      ))}
      {avatars.length > max && (
        <Avatar
          size={size}
          src=""
          alt={`+${avatars.length - max}`}
          className={styles.avatarInAvatarGroup}
        />
      )}
    </div>
  )
}
